"use client";

import React from "react";
import { Plus, Minus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const faqs = [{
    question: "How do you determine the optimal rental price for my property?",
    answer: "We perform a comprehensive market analysis using real-time data from local MLS listings and proprietary databases. We evaluate comparable properties, current demand trends, and unique property features to ensure your investment achieves maximum yield while minimizing vacancy time."
  }, {
    question: "What is your process for screening potential tenants?",
    answer: "Our rigorous screening process includes multi-state criminal background checks, credit evaluations, employment and income verification, and direct contact with previous landlords. We look for high-quality tenants who will treat your property with respect and fulfill their financial obligations."
  }, {
    question: "How are maintenance requests and emergencies handled?",
    answer: "We provide 24/7 emergency response through our dedicated service line. For routine maintenance, we coordinate with our network of vetted, licensed, and insured vendors. Owners can track all work orders and invoices in real-time through our secure digital portal."
  }, {
    question: "When can I expect to receive my monthly rental distributions?",
    answer: "Rental income is typically disbursed via direct deposit by the 10th of each month. Along with your payment, you will receive a detailed monthly statement outlining all income collected and any authorized expenses incurred during the period."
  }, {
    question: "How do you ensure compliance with Florida rental laws?",
    answer: "Our team stays strictly current on Florida Landlord-Tenant statutes and local fair housing regulations. We handle all legal disclosures, lease drafting, and security deposit escrow requirements to protect you from potential liability and legal disputes."
  }, {
    question: "What fees are associated with your management services?",
    answer: "We pride ourselves on a transparent, no-hidden-fee structure. We offer tiered management plans tailored to your specific needs, typically involving a monthly management percentage and a leasing fee. We never charge for marketing or administrative overhead."
  }];
  return;
}